import DUISnackbar from '@tencent/dui/lib/components/Snackbar';
import Toast from '@tencent/dui/lib/components/Toast';
import i18n from '@i18next/i18n';
import { ActionType } from '../../../../editor/src/js/constants/common-action-type';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { OnlineEditServices } from '@src/slide/domain/slide-app/scenes/online/core/online-edit-services.core';
import { openUrlForAll } from '@src/slide/infrastructure/module/independent/url/open-url';

const onCreateDocNew = (response: any): void => {
    const res = response.data;
    openUrlForAll({ url: res.doc_url });
};

const onCatchCreateDocNew = (): void => {
    if (browser.isPCWechat) {
        Toast.show({
            content: i18n.t('新建文档失败，请稍后重试。'),
        });
    } else {
        DUISnackbar.show({
            message: i18n.t('新建文档失败，请稍后重试。'),
            type: 'error',
            autoClose: true,
        });
    }
};

/**
 * 方法里的docType和template_id需确定好再修改
 * 目前使用的是收集表和幻灯片的docType和template_id
 */
export const generateProduceNew = (type: string): void => {
    // 判断pc端微信
    if (browser.isPCWechat) {
        Toast.show({
            content: i18n.t('新建文档中，请稍后...'),
        });
    } else {
        DUISnackbar.show({
            message: i18n.t('新建文档中，请稍后...'),
            type: 'loading',
            autoClose: true,
        });
    }
    // 默认为创建doc文档
    let docType = '0';
    let templateId: number | string = 31227;
    let createType = 2;
    let title = i18n.t('无标题文档');
    switch (type) {
        case ActionType.ONLINE_DOC: {
            docType = '0';
            templateId = 31227;
            createType = 2;
            title = i18n.t('无标题文档');
            break;
        }
        case ActionType.ONLINE_SHEET: {
            docType = '1';
            templateId = '20001';
            createType = 1;
            title = i18n.t('无标题表格');
            break;
        }
        case ActionType.ONLINE_DEMO: {
            docType = '4';
            templateId = '29000';
            createType = 2;
            title = i18n.t('无标题幻灯片');
            break;
        }
        case ActionType.ONLINE_MIND: {
            docType = '90';
            templateId = '';
            createType = 2;
            title = i18n.t('无标题思维导图');
            break;
        }
        case ActionType.ONLINE_FLOWCHART: {
            docType = '91';
            templateId = '';
            createType = 2;
            title = i18n.t('无标题流程图');
            break;
        }
        default:
            break;
    }
    OnlineEditServices.OnlineApiService.promise
        // @ts-ignore
        .then(api => api.createDocNewByTemplate(docType, templateId, title, createType))
        .then(onCreateDocNew)
        .catch(onCatchCreateDocNew);
};

/**
 * 通过模板新建
 */
export const generateProduceTemplate = (): void => {
    const url = `https://${window.hostname}/mall/index/?from_page=doc_detail_new`;
    // @ts-ignore
    if (typeof (external) !== 'undefined' && typeof (external.openUrl) === 'function') {
        // @ts-ignore
        external.openUrl(null, url, null, '');
    } else {
        openUrlForAll({ url });
    }
};

/**
 * @param type 打开的模板页品类
 */
export const openTemplateList = (type: string): void => {
    const PADTYPES = {
        doc: '0',
        form: '2',
        my: '3',
        slide: '4',
    };
    const padtype = PADTYPES[type] || '1';
    let url = `https://${window.hostname}/desktop/templates-list.html?padtype=${padtype}`;
    if (type === 'form') {
        url = `https://${window.hostname}/mall/index/form/collect/?from_page=doc_detail_new_form`;
    }
    // @ts-ignore
    if (typeof (external) !== 'undefined' && typeof (external.openUrl) === 'function') {
        // @ts-ignore
        external.openUrl(null, url, null, '');
    } else {
        const options = {
            url,
            replace: false,
            windowName: '_blank',
        };
        openUrlForAll(options);
    }
};
